import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@heroui/react';
import { getBuildCommit } from '@/utils/buildInfo';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type BuildCommitProps = {
    className?: string;
};

/**
 * The bundle's build commit in small muted text, so the operator can match
 * this front end to the API's health commit. Shown in the sidebar footer.
 */
export const BuildCommit: React.FC<BuildCommitProps> = ({ className }) => {
    const { t } = useTranslation('components');

    return (
        <Typography
            className={className}
            color="muted"
            type="body-xs"
            {...getNodeTestIdProp('build-commit')}
        >
            {t('build.commit', { commit: getBuildCommit() })}
        </Typography>
    );
};
